import React from "react";

function ServerResponse({ response }: { response: string }) {
  // Split the response by newline characters and map to an array of <p> or <br> elements
  const responseElements = response.split("\n").map((line, index) => {
    // Use <br> for all lines except the first one
    return index === 0 ? (
      <p key={index}>{line}</p>
    ) : (
      <React.Fragment key={index}>
        <br />
        {line}
      </React.Fragment>
    );
  });

  // Render the array of elements
  return <div>{responseElements}</div>;
}

export default ServerResponse;
